/* eslint-disable @typescript-eslint/no-magic-numbers */
export const filteredBreeds: number[] = [262, 271, 471, 293, 294, 295];
